<template>
    <v-container v-if="loading" fill-height>
        <v-layout row align-center justify-center fill-height>
            <v-flex shrink>
                <v-progress-circular indeterminate></v-progress-circular>
            </v-flex>
        </v-layout>
    </v-container>
    <v-container v-else :class="`${isTabletMode ? `pa-0` : `pa-2`} flex-row fullWidth fullHeight`" fluid>
        <div class="flex-grow-0">
            <ForecastingUnsent>
            </ForecastingUnsent>
         </div>
         <div class="flex-grow-1 fullWidth fullHeight">
            <div v-show="isOverviewMode" class="fullWidth fullHeight">
                <ForecastingOverview 
                    :routePlantId="routePlantId"
                    :routeProductCategoryId="routeProductCategoryId"
                    :routeCropLocationId="routeCropLocationId"
                    :routeVarietyId="routeVarietyId"
                    @goToDetail="goToDetail($event.cropLocationId, $event.varietyId)">
                </ForecastingOverview>
            </div>
            <ForecastingItem v-if="isDetailMode"
                :crop-location-id="selectedCropLocationId"
                :variety-id="selectedVarietyId"
                :routeForecastMode="routeForecastMode"
                ref="forecastingItem"
                @goBack="goBack()">
            </ForecastingItem>
         </div>
    </v-container>
    
</template>

<script>
import ForecastingUnsent from '@/components/forecasting/ForecastingUnsent.vue'
import ForecastingItem from '@/components/forecasting/ForecastingItem.vue'
import ForecastingOverview from '@/components/forecasting/ForecastingOverview.vue'

import { mapActions } from 'vuex'

export default {
    components: {
        ForecastingUnsent,
        ForecastingItem,
        ForecastingOverview
    },
    props: {
        routePlantId: {
            type: Number,
            required: false
        },
        routeProductCategoryId: {
            type: Number,
            required: false
        },
        routeCropLocationId: {
            type: Number,
            required: false
        },
        routeVarietyId: {
            type: Number,
            required: false
        },
        routeForecastMode: {
            type: Number,
            required: false
        }
    },
    data(){
        return {
            loading: false,
            overviewScroll: 0,
            selectedCropLocationId: null,
            selectedVarietyId: null
        }
    },
    computed: {
        isOverviewMode(){
            return this.selectedCropLocationId == null 
                || this.selectedVarietyId == null;
        },
        isDetailMode(){
            return !this.isOverviewMode;
        },
        isTabletMode(){
            return this.$vuetify.breakpoint.mdAndDown;
        }
    },
    methods: {
        ...mapActions("ForecastingStore", [
            "loadFinancialYearCalendarData",
            "loadPlants", 
            "loadNoteAlertCategories",
            "loadUnsentStatus",
            "updateData"
        ]),
        async init(){
            this.loading = true;

            await Promise.all([
                this.loadFinancialYearCalendarData(),
                this.loadPlants(),
                this.loadNoteAlertCategories(),
                this.loadUnsentStatus()
            ]);

            await this.updateData();

            this.loading = false;
        },
        goToDetail(cropLocationId, varietyId){
            this.overviewScroll = document.body.parentElement.scrollTop;

            this.selectedCropLocationId = cropLocationId;
            this.selectedVarietyId = varietyId;
        },
        goBack(){
            this.selectedCropLocationId = null;
            this.selectedVarietyId = null;

            this.$nextTick(() => {
                document.body.parentElement.scrollTop = this.overviewScroll;
            })
        }
    },
    created(){
        this.init();
    }
}
</script>
<style scoped>
    .fullWidth {
        width: 100%;
    }
    .fullHeight {
        height: 100%;
    }
</style>